import { Theme, Typography, makeStyles, createStyles } from "@material-ui/core";
import { useInvoice } from "../contexts/InvoiceContext";
import { InvoiceType } from "../models/InvoiceDTO";
import { GetLabels } from "../utils/InvoiceLabels";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    documentTitle: {
      color: '#0000008a',
      alignSelf: 'center',
    }
  })
);

const DocumentTitle: React.FunctionComponent = () => {
  const classes = useStyles();
  const { invoice } = useInvoice();
  let labels = null;
  let isProForma = false;

  if (invoice !== null) {
      labels = GetLabels(invoice);
      isProForma = invoice.type === InvoiceType.ProForma;
  }

  return (
    <>
      {invoice && (
        <Typography variant="h5" gutterBottom className={classes.documentTitle}>
          {labels!.header}
          {isProForma && (
            <div>
              <Typography variant="subtitle2" className={classes.documentTitle}>
                {labels!.subHeader}
              </Typography>
            </div>
          )}
        </Typography>
      )}
    </>
  )
};

export default DocumentTitle;
